import { Row } from 'antd';
import './Logo.css';
// Triple check this path: it must go out of Logo, LeftPanel, and components
import mgLogo from '../../../assets/logo-malta.png'; 

const Logo = () => {
    // This will help us debug in the browser console
    if (!mgLogo) console.error("MG Logo path error: check assets folder");

    return (
        <Row>
            <div className="logo-header-container">
                <img 
                    src={mgLogo} 
                    className="mg-logo-small" 
                    alt="MG Logo" 
                />
                <div className='title'>MG Sicily Drive 2026</div>
            </div>
        </Row>
    )
}

export default Logo;